import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, Fragment as _Fragment, createBlock as _createBlock } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "nav--home"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("img", {
  class: "nav--logo",
  src: "/img/ifc.jpg"
}, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Icon = _resolveComponent("Icon")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_nav_breadcrumb = _resolveComponent("nav-breadcrumb")!
  const _component_nav_menu = _resolveComponent("nav-menu")!
  const _component_nav_language = _resolveComponent("nav-language")!
  const _component_nav_dropdown = _resolveComponent("nav-dropdown")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (_ctx.mobileVersion)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createVNode(_component_router_link, { to: "/dashboard" }, {
            default: _withCtx(() => [
              _createVNode(_component_Icon, { icon: "ic:baseline-menu" })
            ]),
            _: 1
          })
        ]))
      : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
          _hoisted_2,
          _createElementVNode("div", {
            class: _normalizeClass(['nav--title', { 'is-staff': _ctx.isStaff }])
          }, _toDisplayString(_ctx.title), 3)
        ], 64)),
    (_ctx.mobileVersion)
      ? (_openBlock(), _createBlock(_component_nav_breadcrumb, { key: 2 }))
      : _createCommentVNode("", true),
    (!_ctx.mobileVersion)
      ? (_openBlock(), _createBlock(_component_nav_menu, { key: 3 }))
      : _createCommentVNode("", true),
    _createElementVNode("div", {
      class: _normalizeClass(['nav--bottom', { 'is-mobile': _ctx.mobileVersion }])
    }, [
      _createVNode(_component_nav_language),
      _createVNode(_component_nav_dropdown)
    ], 2)
  ], 64))
}